import fullcatalog from '@/assets/images/rever-store/full-catalog.png'
import protect from '@/assets/images/rever-store/protect.png'
import tracking from '@/assets/images/rever-store/tracking.png'
import customization from '@/assets/images/rever-store/customization.png'
import warranty from '@/assets/images/rever-store/warranty.png'
import offline from '@/assets/images/rever-store/offline.png'
import logistics from '@/assets/images/rever-store/logistics.png'

const FullCatalog = () => {
  return (
    <>
      <div className="flex h-full flex-col justify-between text-left">
        <div>
          <div className="font-logo text-sm uppercase">
            Full catalog exchanges
          </div>
          <p className="mt-1 text-lg font-semibold leading-5">
            Turn Returns Into Upselling.
          </p>
        </div>
        <img
          className="my-auto w-full p-1"
          src={fullcatalog}
          alt="full catalog exchanges"
        />
      </div>
    </>
  )
}
const ReverProtect = () => {
  return (
    <>
      <div className="flex h-full flex-col justify-between text-left">
        <div>
          <div className="font-logo text-sm uppercase">Rever protect</div>
          <p className="mt-1 text-lg font-semibold leading-5">
            Secure Your Business From Fraudulent Returns.
          </p>
        </div>
        <img className="mt-3 w-9/12 self-center p-1" src={protect} />
      </div>
    </>
  )
}
const TrackingInterface = () => {
  return (
    <>
      <div className="relative flex h-full flex-col justify-between text-left">
        <div>
          <div className="font-logo text-sm uppercase">Tracking interface</div>
          <p className=" mt-1 max-w-[80%] text-lg font-semibold leading-5">
            Real-Time Tracking On Return & Refund Status.
          </p>
        </div>
        <img className="absolute -top-2 right-0 scale-125" src={tracking} />
      </div>
    </>
  )
}
const OfflineReturns = () => {
  return (
    <>
      <div className="flex h-full flex-col justify-between text-left">
        <div>
          <div className="font-logo text-sm uppercase">Offline returns</div>
          <p className="mt-1 text-lg font-semibold leading-5">
            Go Omnichannel. <br /> Returns In-store.
          </p>
        </div>
        <img className="w-full self-center" src={offline} />
      </div>
    </>
  )
}
const WarrantyManagement = () => {
  return (
    <>
      <div className="flex h-full flex-col justify-between text-left">
        <div>
          <div className="font-logo text-sm uppercase">Warranty management</div>
          <p className="mt-1 text-lg font-semibold leading-5">
            Manage Warranty Claims & Exceptions.
          </p>
        </div>
        <img className="mb-2 ml-2 mt-3 w-9/12 self-center" src={warranty} />
      </div>
    </>
  )
}
const Customization = () => {
  return (
    <>
      <div className="flex h-full flex-col justify-between text-left">
        <div>
          <div className="font-logo text-sm uppercase">Customization</div>
          <p className="mt-1 text-lg font-semibold leading-5">
            Make it{' '}
            <span className="bg-gradient-to-r from-pink-500 via-yellow-300 to-lime-400 bg-clip-text text-transparent">
              You-Nique.
            </span>
            <br />
            Fully Branded Process.
          </p>
        </div>
        <img
          className="mb-4 ml-2 mt-3 w-8/12 self-center"
          src={customization}
        />
      </div>
    </>
  )
}
const ReverLogistics = () => {
  return (
    <>
      <div className="flex h-full flex-col justify-between text-left">
        <div>
          <div className="font-logo text-sm uppercase">Rever Logistics</div>
          <p className="mt-1 text-lg font-semibold leading-5">
            Benefit From REVER Logistics Deals.
          </p>
        </div>
        <img className="mb-2 ml-2 mt-3 w-full self-center" src={logistics} />
      </div>
    </>
  )
}
export {
  FullCatalog,
  ReverProtect,
  TrackingInterface,
  OfflineReturns,
  WarrantyManagement,
  Customization,
  ReverLogistics
}
